import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { TourBuilder, TourStep } from '../tour.types';
import { Buttons } from '../tour.buttons';
import { TourIntentService } from '../tour-intent.service';
import { APP_ROUTES } from '@core/constants';

@Injectable()
export class DashboardTourBuilder implements TourBuilder {
  key = 'dashboard';

  defaults: Partial<TourStep> = {
    scrollTo: { behavior: 'smooth', block: 'center' } as const
  };

  constructor(private router: Router, private zone: NgZone, private intent: TourIntentService) {}

  buildSteps(): TourStep[] {
    const router = this.router;
    const zone = this.zone;
    const intent = this.intent;

    return [
      {
        id: 'welcome',
        text: `
          <img class="tour-img" src="/assets/tours/profile-details.svg" alt="profile setup wizard" loading="lazy"/>
          <h2 class="tour-title">👋 Welcome to Hivve!</h2>
          <div class="tour-text">
            Begin your onboarding journey by setting up your profile. We'll guide you through each step.
          </div>
        `,
        classes: 'shepherd-theme-dialog',
        buttons: [Buttons.skip(), Buttons.next('Let’s begin')]
      },
      {
        id: 'go-to-profile',
        attachTo: {
          element: '[data-tour-id="dashboard-go-to-profile"]',
          on: 'right'
        },
        text: `
          <p>
            Click <strong>Next</strong> to go to <strong>Account Settings</strong> to complete your profile details.
          </p>
        `,
        classes: 'shepherd-theme-step arrow-nudge-go-profile',
        scrollTo: false,
        canClickTarget: true,
        arrow: true,
        highlightClass: 'tour-highlight-exact',
        beforeShowPromise: () =>
          new Promise<void>((resolve, reject) => {
            const selector = '[data-tour-id="dashboard-go-to-profile"]';
            const toggle = document.getElementById('acctMenuBtn') as HTMLElement | null;

            if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
              toggle.click();
            }

            const deadline = performance.now() + 2000;
            const check = () => {
              const item = document.querySelector(selector);

              if (item) {
                item.classList.add('tour-highlight-pulse');
                item.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return resolve();
              }

              if (performance.now() > deadline) {
                return reject(new Error('profile menu item not found'));
              }

              setTimeout(check, 50);
            };
            check();
          }),

        buttons: [
          {
            text: 'Next',
            classes: 'shepherd-btn shepherd-btn-primary',
            action: function (this: any) {
              // Set intent so the Profile page auto-runs its tour on arrival.
              intent.setIntent('profile', {
                progress: true,
                progressPlacement: 'after-footer',
                requiredSelectors: ['[data-tour-id="profile-title"]']
              });

              this.complete();
              zone.run(() => void router.navigate([`/${APP_ROUTES.PROFILE}`]));
            }
          }
        ]
      }
    ];
  }
}
